import { supabase } from './supabase';

export const VILLA_SLUGS = [
  'villa-buenlugar',
  'casa-de-la-villaflor',
  'casa-de-el-golfo',
] as const;

interface BookingOverlap {
  villa_slug: string;
  check_in: string;
  check_out: string;
}

/**
 * Returns the set of villa slugs that ARE available for the given date range.
 * A booking blocks a villa when the ranges overlap:
 *   booking.check_in < checkOut  AND  booking.check_out > checkIn
 */
export async function checkVillasAvailability(
  checkIn: string,
  checkOut: string,
  slugs: string[]
): Promise<Set<string>> {
  const { data, error } = await supabase
    .from('bookings')
    .select('villa_slug, check_in, check_out')
    .in('villa_slug', slugs)
    .neq('status', 'cancelled');

  if (error) throw error;

  const available = new Set<string>(slugs);
  const rows = (data || []) as BookingOverlap[];

  rows.forEach((booking) => {
    if (booking.check_in < checkOut && booking.check_out > checkIn) {
      available.delete(booking.villa_slug);
    }
  });

  return available;
}